module.exports = __webpack_public_path__ + "img/1530140501.a5582deb.jpg";